import { useState, useEffect } from 'react';
import {
    ProfileInfo,
    identityApiRef,
    useApi,
} from '@backstage/core-plugin-api';

export function useCurrentProfile(): {
    identity: ProfileInfo | undefined;
    loading: boolean;
} {
    const identityApi = useApi(identityApiRef);
    const [loading, setLoading] = useState(true);
    const [identity, setIdentity] = useState<ProfileInfo | undefined>(
        undefined,
    );

    useEffect(() => {
        async function fetchIdentity() {
            const res = await identityApi.getProfileInfo();
            setLoading(false);
            setIdentity(res);
        }
        fetchIdentity();
    }, [identityApi]);

    return { loading: loading, identity: identity };
}
